// store/couponSlice.js
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { validateCoupon } from "../services/couponValidateServices";

// Thunk for validating a coupon
export const validateCouponAsync = createAsyncThunk(
  "coupon/validate",
  async (couponCode, { rejectWithValue }) => {
    try {
      const response = await validateCoupon(couponCode);

      // if backend sends {status:"failed"} but HTTP 200
      if (response.status === "failed") {
        return rejectWithValue(response.message);
      }

      return response;
    } catch (error) {
      // handle network/server errors
      return rejectWithValue(error.message || "Something went wrong");
    }
  }
);

const couponSlice = createSlice({
  name: "coupon",
  initialState: {
    code: "",
    discount: 0,
    isValid: false,
    status: "idle", // 'idle' | 'loading' | 'succeeded' | 'failed'
    error: null,
  },
  reducers: {
    clearCoupon: (state) => {
      state.code = "";
      state.discount = 0;
      state.isValid = false;
      state.status = "idle";
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(validateCouponAsync.pending, (state) => {
        state.status = "loading";
        state.error = null;
      })
      .addCase(validateCouponAsync.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.isValid = action.payload.status === "success";
        state.discount = action.payload.data?.discount || 0;
        state.code = action.meta.arg;
        state.error = null;
      })
      .addCase(validateCouponAsync.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
        state.isValid = false;
        state.discount = 0;
      });
  },
});

export const { clearCoupon } = couponSlice.actions;
export default couponSlice.reducer;
